import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { ResponseObject } from 'src/app/models/response-object.model';

@Component({
  selector: 'app-clients-inactive-days',
  templateUrl: './clients-inactive-days.component.html',
  styleUrls: ['./clients-inactive-days.component.scss']
})
export class ClientsInactiveDaysComponent {
  loaded = false;
  loading = false;

  rows: any[] = [];

  filter = '';

  constructor(
    private invoiceService: InvoiceSaleService,
    private toastService: ToastrService
  ) {}

  fetchClients(): void {
    this.loading = true;

    this.invoiceService.getLastInvoicesClientDays().subscribe({
      next: (response : ResponseObject) => {
        const data = response.data as any[];
        this.rows = (data ?? []).map(r => ({
          ...r,
          lastPurchaseDate: r.lastPurchaseDate
        }));
        this.loaded = true;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.loaded = true;
        this.toastService.error('Error al consultar clientes');
        console.error(err);
      }
    });
  }

  clear(): void {
    this.rows = [];
    this.filter = '';
    this.loaded = false;
  }

  get filteredRows() {
    const q = this.filter.trim().toLowerCase();

    if (!q) return this.rows;

    return this.rows.filter(r => {
      const nit = (r.nit ?? '').toLowerCase();
      const name = (r.name ?? '').toLowerCase();
      return nit.includes(q) || name.includes(q);
    });
  }


  rowClass(days: number): string {
    if (days >= 10) return 'row-red';
    if (days >= 5) return 'row-yellow';
    return 'row-green';
  }
}
